import React, { Component } from "react"
import AppContext from "./index"
import Client from "../client"

export const client = new Client()

class Provider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      completedBooks: new Map(),
    }

    this.toggleBookComplete = this.toggleBookComplete.bind(this)
    this.loadBooks = this.loadBooks.bind(this)
  }

  componentDidMount() {
    this.loadBooks()
  }

  loadBooks() {
    client.db.completedBooks
      .toArray()
      .then(books => {
        this.setState({ completedBooks: new Map(books.map(book => [book.url, book])) })
      })
      .catch(error => console.error(error))
  }

  toggleBookComplete(event, book, age) {
    event.preventDefault()

    // Making a copy of our state map to promote immutability of our
    // data structure
    const bookMap = new Map(this.state.completedBooks)
    const url = `https://www.ehonnavi.net${book.url}`
    const isBookPresent = bookMap.has(url)

    if (isBookPresent) {
      bookMap.delete(url)
      client.db.completedBooks
        .delete(url)
        .then(() => console.log("Deleted record with url: ", url))
        .catch(error => console.error(error))
    } else {
      bookMap.set(url, { url, title: book.title, age })
      client.db.completedBooks
        .put({ url, title: book.title, age })
        .then(key => console.log("Saved record under key: ", key))
        .catch(error => console.error(error))
    }

    this.setState({ completedBooks: bookMap })
  }

  render() {
    return (
      <AppContext.Provider
        value={{
          completedBooks: this.state.completedBooks,
          toggleBookComplete: this.toggleBookComplete,
          loadBooks: this.loadBooks,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    )
  }
}

export default Provider
